export default __webpack_public_path__ + "static/milos-tancibudek-a66d8484e12c97da4d5a18e9c8421904.jpg";